import {
  GET_ALL_APPLICATIONS,
  GET_ALL_APPLICATIONS_FAILURE,
  GET_ALL_APPLICATIONS_SUCCESS,
  ADD_APPLICATION,
  ADD_APPLICATION_FAILURE,
  ADD_APPLICATION_SUCCESS,
  DELETE_APPLICATION,
  DELETE_APPLICATION_FAILURE,
  DELETE_APPLICATION_SUCCESS,
  EDIT_APPLICATION,
  EDIT_APPLICATION_FAILURE,
  EDIT_APPLICATION_SUCCESS,
  GET_APPLICATION,
  GET_APPLICATION_FAILURE,
  GET_APPLICATION_SUCCESS,
  REFRESH_CLIENT_TOKEN,
  REFRESH_CLIENT_TOKEN_SUCCESS,
  REFRESH_CLIENT_TOKEN_FAILURE,
} from "./actionTypes";

export const getAllApplications = (payload) => {
  return {
    type: GET_ALL_APPLICATIONS,
    payload: payload,
  };
};
export const getAllApplicationsSuccess = (payload) => {
  return {
    type: GET_ALL_APPLICATIONS_SUCCESS,
    payload: payload,
  };
};

export const getAllApplicationsFailure = (error) => {
  return {
    type: GET_ALL_APPLICATIONS_FAILURE,
    payload: error,
  };
};

export const addApplication = (payload) => {
  return {
    type: ADD_APPLICATION,
    payload: payload,
  };
};
export const addApplicationSuccess = (payload) => {
  return {
    type: ADD_APPLICATION_SUCCESS,
    payload: payload,
  };
};

export const addApplicationFailure = (error) => {
  return {
    type: ADD_APPLICATION_FAILURE,
    payload: error,
  };
};

export const getApplication = (payload) => {
  return {
    type: GET_APPLICATION,
    payload: payload,
  };
};
export const getApplicationSuccess = (payload) => {
  return {
    type: GET_APPLICATION_SUCCESS,
    payload: payload,
  };
};

export const getApplicationFailure = (error) => {
  return {
    type: GET_APPLICATION_FAILURE,
    payload: error,
  };
};

export const editApplication = (payload) => {
  return {
    type: EDIT_APPLICATION,
    payload: payload,
  };
};
export const editApplicationSuccess = (payload) => {
  return {
    type: EDIT_APPLICATION_SUCCESS,
    payload: payload,
  };
};

export const editApplicationFailure = (error) => {
  return {
    type: EDIT_APPLICATION_FAILURE,
    payload: error,
  };
};

export const deleteApplication = (payload) => {
  return {
    type: DELETE_APPLICATION,
    payload: payload,
  };
};

export const deleteApplicationSuccess = (payload) => {
  return {
    type: DELETE_APPLICATION_SUCCESS,
    payload: payload,
  };
};

export const deleteApplicationFailure = (error) => {
  return {
    type: DELETE_APPLICATION_FAILURE,
    payload: error,
  };
};

export const refreshClientToken = (payload) => {
  return {
    type: REFRESH_CLIENT_TOKEN,
    payload: payload,
  };
};

export const refreshClientTokenSuccess = (payload) => {
  return {
    type: REFRESH_CLIENT_TOKEN_SUCCESS,
    payload: payload,
  };
};

export const refreshClientTokenFailure = (error) => {
  return {
    type: REFRESH_CLIENT_TOKEN_FAILURE,
    payload: error,
  };
};
